import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE = '[VeranstaltungenModul] GetFunkprotokollVorlagenListe laden';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollVorlagenListe ausführen';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollVorlagenListe laden erfolgreich';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_FEHLER = '[VeranstaltungenModul] GetFunkprotokollVorlagenListe Ladefehler';
export const GET_FUNKPROTOKOLL_VORLAGEN_LISTE_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollVorlagenListe nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollVorlagenListeAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ERFOLGREICH;
        constructor(public payload: Array<api.FunkprotokollVorlageDetail>, public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlagenListeNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGEN_LISTE_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollVorlagenListeActions =
    GetFunkprotokollVorlagenListeAction
    | GetFunkprotokollVorlagenListeAusfuehrenAction
    | GetFunkprotokollVorlagenListeErfolgreichAction
    | GetFunkprotokollVorlagenListeFehlerAction
    | GetFunkprotokollVorlagenListeNichtAusgefuehrtAction
    ;
